import { render, staticRenderFns } from "./custom-checkbox-group.vue?vue&type=template&id=61dc6d38&"
import script from "./custom-checkbox-group.vue?vue&type=script&lang=js&"
export * from "./custom-checkbox-group.vue?vue&type=script&lang=js&"
import style0 from "./custom-checkbox-group.vue?vue&type=style&index=0&id=61dc6d38&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports